import { Gmoshop } from '@linktivity/link-connect';
import config from '../config';

const orderApi = new Gmoshop.OrderApi(config);

export default orderApi;
